import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';

export default function PolitiqueConfidentialite() {
  return (
    <div className="min-h-screen bg-white font-[Manrope,sans-serif]">
      <Navbar />

      <section className="pt-40 pb-20 bg-[#0A1628]">
        <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
          <span className="inline-block px-4 py-1.5 border border-white/20 rounded-full text-xs font-semibold tracking-widest uppercase text-white/50 mb-6">
            Légal
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-white">Politique de confidentialité</h1>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          <div className="bg-[#F7F8FA] rounded-2xl p-6 mb-12 flex items-start gap-4">
            <div className="w-10 h-10 flex items-center justify-center bg-[#0A1628] rounded-xl flex-shrink-0">
              <i className="ri-shield-check-line text-white text-lg" />
            </div>
            <div>
              <p className="font-bold text-[#0A1628] mb-1">Protection de vos données</p>
              <p className="text-[#374151] text-sm leading-relaxed">
                CICHORZ s&apos;engage à protéger la vie privée de ses utilisateurs et à traiter leurs données personnelles
                avec la plus grande confidentialité, conformément au RGPD.
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-10">
            <div>
              <h2 className="text-2xl font-bold text-[#0A1628] mb-4">1. Responsable du traitement</h2>
              <p className="text-[#374151] text-base leading-relaxed">
                Le responsable du traitement des données est Mariusz Slawomir Cichorz, entrepreneur individuel,
                SIRET 102 737 178 00016, domicilié au 57 Rue Lecourbe, 75015 Paris, France.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#0A1628] mb-4">2. Données collectées</h2>
              <p className="text-[#374151] text-base leading-relaxed mb-4">
                Le site peut collecter les données personnelles suivantes via le formulaire de contact :
              </p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: 'ri-user-line', label: 'Nom et prénom' },
                  { icon: 'ri-mail-line', label: 'Adresse email' },
                  { icon: 'ri-phone-line', label: 'Numéro de téléphone' },
                  { icon: 'ri-message-2-line', label: 'Message / Description du projet' },
                ].map((item) => (
                  <div key={item.label} className="flex items-center gap-3 bg-[#F7F8FA] rounded-xl p-4">
                    <span className="w-8 h-8 flex items-center justify-center bg-[#0A1628] rounded-lg">
                      <i className={`${item.icon} text-white text-sm`} />
                    </span>
                    <span className="text-[#374151] text-sm font-medium">{item.label}</span>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#0A1628] mb-4">3. Finalité du traitement</h2>
              <p className="text-[#374151] text-base leading-relaxed">
                Ces données sont collectées et utilisées uniquement dans le but de répondre aux demandes
                adressées via le formulaire de contact. Elles ne font l&apos;objet d&apos;aucun autre traitement.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#0A1628] mb-4">4. Conservation des données</h2>
              <p className="text-[#374151] text-base leading-relaxed">
                Les données personnelles sont conservées le temps nécessaire au traitement de la demande
                et supprimées dès que la relation commerciale prend fin, sauf obligation légale contraire.
              </p>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#0A1628] mb-4">5. Partage des données</h2>
              <div className="bg-[#F7F8FA] rounded-xl p-5 flex items-center gap-4">
                <span className="w-10 h-10 flex items-center justify-center bg-[#0A1628] rounded-xl flex-shrink-0">
                  <i className="ri-lock-line text-white text-lg" />
                </span>
                <p className="text-[#374151] text-base leading-relaxed">
                  <strong className="text-[#0A1628]">Vos données ne sont ni vendues, ni partagées, ni louées</strong>{' '}
                  à des tiers. Elles restent strictement confidentielles et utilisées uniquement pour vous contacter.
                </p>
              </div>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#0A1628] mb-4">6. Vos droits</h2>
              <p className="text-[#374151] text-base leading-relaxed mb-4">
                Conformément au RGPD, vous disposez des droits suivants concernant vos données :
              </p>
              <ul className="flex flex-col gap-2">
                {[
                  'Droit d\'accès à vos données personnelles',
                  'Droit de rectification des données inexactes',
                  'Droit à l\'effacement de vos données',
                  'Droit d\'opposition au traitement',
                ].map((right) => (
                  <li key={right} className="flex items-center gap-3 text-[#374151] text-base">
                    <span className="w-5 h-5 flex items-center justify-center rounded-full bg-[#0A1628] flex-shrink-0">
                      <i className="ri-check-line text-white text-xs" />
                    </span>
                    {right}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h2 className="text-2xl font-bold text-[#0A1628] mb-4">7. Contact</h2>
              <p className="text-[#374151] text-base leading-relaxed">
                Pour exercer vos droits ou pour toute question relative à la protection de vos données personnelles,
                contactez-nous à :{' '}
                <a
                  href="mailto:mariuszcichorz@inbox.eu"
                  className="text-[#0A1628] underline font-medium cursor-pointer"
                >
                  mariuszcichorz@inbox.eu
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
